exports.autotaskBoxImg = 'https://cdn.simplesat.io/images/box-autotask.png'
exports.zendeskBoxImg = 'https://cdn.simplesat.io/images/box-zendesk.png'
exports.connectwiseBoxImg = 'https://cdn.simplesat.io/images/box-connectwise.png'
exports.genericEmbedBoxImg = 'https://cdn.simplesat.io/images/box-generic_embed.png'
exports.intercomBoxImg = 'https://cdn.simplesat.io/images/box-intercom.svg'
exports.zapierBoxImg = 'https://cdn.simplesat.io/images/box-zapier.png'
exports.slackBoxImg = 'https://cdn.simplesat.io/images/slack-logo.png'
exports.microsoftTeamsBoxImg = 'https://cdn.simplesat.io/images/microsoft-teams-logo.png'
exports.keapBoxImg = 'https://cdn.simplesat.io/images/keap-logo.png'
exports.dropboxBoxImg = 'https://cdn.simplesat.io/images/DropboxGlyph_Blue.png?crop=183,122,250,250'

exports.emailTypeBoxImg = 'https://cdn.simplesat.io/images/icon-envelope.svg'
exports.embedTypeBoxImg = 'https://cdn.simplesat.io/images/icon-coding.svg'
exports.freshdeskBoxImg = 'https://cdn.simplesat.io/images/box-freshdesk.png'

exports.csatTypeBoxImg = 'https://cdn.simplesat.io/images/survey_csat_metric.png'
exports.npsTypeBoxImg = 'https://cdn.simplesat.io/images/survey_nps_metric.png'
exports.cesTypeBoxImg = 'https://cdn.simplesat.io/images/survey_ces_metric.png'
exports.starTypeBoxImg = 'https://cdn.simplesat.io/images/5-STAR/survey_5star_metric.png'

exports.emailSkeleton = 'https://cdn.simplesat.io/images/email-skeleton.png'

exports.smilie = {
  positive: 'https://cdn.simplesat.io/images/positive-smilie-static-3.png',
  neutral: 'https://cdn.simplesat.io/images/neutral-smilie-static-3.png',
  negative: 'https://cdn.simplesat.io/images/negative-smilie-static-3.png',
  1: 'https://cdn.simplesat.io/images/smiley-1.png',
  2: 'https://cdn.simplesat.io/images/smiley-2.png',
  3: 'https://cdn.simplesat.io/images/smiley-3.png',
  4: 'https://cdn.simplesat.io/images/smiley-4.png',
  5: 'https://cdn.simplesat.io/images/smiley-5.png',
}

exports.smilieStatic = {
  small: {
    positive: 'https://cdn.simplesat.io/images/smilie-positive@100x100.png',
    neutral: 'https://cdn.simplesat.io/images/smilie-neutral@100x100.png',
    negative: 'https://cdn.simplesat.io/images/smilie-negative@100x100.png',
    1: 'https://cdn.simplesat.io/images/smiley2-1.5@100.png',
    2: 'https://cdn.simplesat.io/images/smiley2-2.5@100.png',
    3: 'https://cdn.simplesat.io/images/smiley2-3.5@100.png',
    4: 'https://cdn.simplesat.io/images/smiley2-4.5@100.png',
    5: 'https://cdn.simplesat.io/images/smiley2-5.5@100.png',
  },

  big: {
    positive: 'https://cdn.simplesat.io/images/smilie-positive@300x300.png',
    neutral: 'https://cdn.simplesat.io/images/smilie-neutral@300x300.png',
    negative: 'https://cdn.simplesat.io/images/smilie-negative@300x300.png',
    1: 'https://cdn.simplesat.io/images/smiley2-1.5@300.png',
    2: 'https://cdn.simplesat.io/images/smiley2-2.5@300.png',
    3: 'https://cdn.simplesat.io/images/smiley2-3.5@300.png',
    4: 'https://cdn.simplesat.io/images/smiley2-4.5@300.png',
    5: 'https://cdn.simplesat.io/images/smiley2-5.5@300.png',
  },
}

exports.smilieAnimated = {
  small: {
    positive: 'https://cdn.simplesat.io/images/smilie-positive@100x100.gif',
    neutral: 'https://cdn.simplesat.io/images/smilie-neutral@100x100.gif',
    negative: 'https://cdn.simplesat.io/images/smilie-negative@100x100.gif',
    1: 'https://cdn.simplesat.io/images/smiley2-1.5@100.gif',
    2: 'https://cdn.simplesat.io/images/smiley2-2.5@100.gif',
    3: 'https://cdn.simplesat.io/images/smiley2-3.5@100.gif',
    4: 'https://cdn.simplesat.io/images/smiley2-4.5@100.gif',
    5: 'https://cdn.simplesat.io/images/smiley2-5.5@100.gif',
  },

  big: {
    positive: 'https://cdn.simplesat.io/images/smilie-positive@300x300.gif',
    neutral: 'https://cdn.simplesat.io/images/smilie-neutral@300x300.gif',
    negative: 'https://cdn.simplesat.io/images/smilie-negative@300x300.gif',
    1: 'https://cdn.simplesat.io/images/smiley2-1.5@300.gif',
    2: 'https://cdn.simplesat.io/images/smiley2-2.5@300.gif',
    3: 'https://cdn.simplesat.io/images/smiley2-3.5@300.gif',
    4: 'https://cdn.simplesat.io/images/smiley2-4.5@300.gif',
    5: 'https://cdn.simplesat.io/images/smiley2-5.5@300.gif',
  },
}

exports.thumbStatic = {
  small: {
    positive: 'https://cdn.simplesat.io/images/thumb-positive@100x100.png',
    neutral: 'https://cdn.simplesat.io/images/thumb-neutral@100x100.png',
    negative: 'https://cdn.simplesat.io/images/thumb-negative@100x100.png',
    1: 'https://cdn.simplesat.io/images/hand-1.5@100.png',
    2: 'https://cdn.simplesat.io/images/hand-2.5@100.png',
    3: 'https://cdn.simplesat.io/images/hand-3.5@100.png',
    4: 'https://cdn.simplesat.io/images/hand-4.5@100.png',
    5: 'https://cdn.simplesat.io/images/hand-5.5@100.png',
  },

  big: {
    positive: 'https://cdn.simplesat.io/images/thumb-positive@300x300.png',
    neutral: 'https://cdn.simplesat.io/images/thumb-neutral@300x300.png',
    negative: 'https://cdn.simplesat.io/images/thumb-negative@300x300.png',
    1: 'https://cdn.simplesat.io/images/hand-1.5@300.png',
    2: 'https://cdn.simplesat.io/images/hand-2.5@300.png',
    3: 'https://cdn.simplesat.io/images/hand-3.5@300.png',
    4: 'https://cdn.simplesat.io/images/hand-4.5@300.png',
    5: 'https://cdn.simplesat.io/images/hand-5.5@300.png',
  },
}

exports.thumbAnimated = {
  small: {
    positive: 'https://cdn.simplesat.io/images/thumb-positive@100x100.gif',
    neutral: 'https://cdn.simplesat.io/images/thumb-neutral@100x100.gif',
    negative: 'https://cdn.simplesat.io/images/thumb-negative@100x100.gif',
    1: 'https://cdn.simplesat.io/images/hand-1.5@100.gif',
    2: 'https://cdn.simplesat.io/images/hand-2.5@100.gif',
    3: 'https://cdn.simplesat.io/images/hand-3.5@100.gif',
    4: 'https://cdn.simplesat.io/images/hand-4.5@100.gif',
    5: 'https://cdn.simplesat.io/images/hand-5.5@100.gif',
  },

  big: {
    positive: 'https://cdn.simplesat.io/images/thumb-positive@300x300.gif',
    neutral: 'https://cdn.simplesat.io/images/thumb-neutral@300x300.gif',
    negative: 'https://cdn.simplesat.io/images/thumb-negative@300x300.gif',
    1: 'https://cdn.simplesat.io/images/hand-1.5@300.gif',
    2: 'https://cdn.simplesat.io/images/hand-2.5@300.gif',
    3: 'https://cdn.simplesat.io/images/hand-3.5@300.gif',
    4: 'https://cdn.simplesat.io/images/hand-4.5@300.gif',
    5: 'https://cdn.simplesat.io/images/hand-5.5@300.gif',
  },
}

exports.cloudStatic = {
  small: {
    positive: 'https://cdn.simplesat.io/images/cloud-positive@100x100.png',
    neutral: 'https://cdn.simplesat.io/images/cloud-neutral@100x100.png',
    negative: 'https://cdn.simplesat.io/images/cloud-negative@100x100.png',
    1: 'https://cdn.simplesat.io/images/cloud-1.5@100.png',
    2: 'https://cdn.simplesat.io/images/cloud-2.5@100.png',
    3: 'https://cdn.simplesat.io/images/cloud-3.5@100.png',
    4: 'https://cdn.simplesat.io/images/cloud-4.5@100.png',
    5: 'https://cdn.simplesat.io/images/cloud-5.5@100.png',
  },

  big: {
    positive: 'https://cdn.simplesat.io/images/cloud-positive@300x300.png',
    neutral: 'https://cdn.simplesat.io/images/cloud-neutral@300x300.png',
    negative: 'https://cdn.simplesat.io/images/cloud-negative@300x300.png',
    1: 'https://cdn.simplesat.io/images/cloud-1.5@300.png',
    2: 'https://cdn.simplesat.io/images/cloud-2.5@300.png',
    3: 'https://cdn.simplesat.io/images/cloud-3.5@300.png',
    4: 'https://cdn.simplesat.io/images/cloud-4.5@300.png',
    5: 'https://cdn.simplesat.io/images/cloud-5.5@300.png',
  },
}

exports.cloudAnimated = {
  small: {
    positive: 'https://cdn.simplesat.io/images/cloud-positive@100x100.gif',
    neutral: 'https://cdn.simplesat.io/images/cloud-neutral@100x100.gif',
    negative: 'https://cdn.simplesat.io/images/cloud-negative@100x100.gif',
    1: 'https://cdn.simplesat.io/images/cloud-1.5@100.gif',
    2: 'https://cdn.simplesat.io/images/cloud-2.5@100.gif',
    3: 'https://cdn.simplesat.io/images/cloud-3.5@100.gif',
    4: 'https://cdn.simplesat.io/images/cloud-4.5@100.gif',
    5: 'https://cdn.simplesat.io/images/cloud-5.5@100.gif',
  },

  big: {
    positive: 'https://cdn.simplesat.io/images/cloud-positive@300x300.gif',
    neutral: 'https://cdn.simplesat.io/images/cloud-neutral@300x300.gif',
    negative: 'https://cdn.simplesat.io/images/cloud-negative@300x300.gif',
    1: 'https://cdn.simplesat.io/images/cloud-1.5@300.gif',
    2: 'https://cdn.simplesat.io/images/cloud-2.5@300.gif',
    3: 'https://cdn.simplesat.io/images/cloud-3.5@300.gif',
    4: 'https://cdn.simplesat.io/images/cloud-4.5@300.gif',
    5: 'https://cdn.simplesat.io/images/cloud-5.5@300.gif',
  },
}

exports.catStatic = {
  small: {
    1: 'https://cdn.simplesat.io/images/cat-1.5@100.png',
    2: 'https://cdn.simplesat.io/images/cat-2.5@100.png',
    3: 'https://cdn.simplesat.io/images/cat-3.5@100.png',
    4: 'https://cdn.simplesat.io/images/cat-4.5@100.png',
    5: 'https://cdn.simplesat.io/images/cat-5.5@100.png',
  },
  big: {
    1: 'https://cdn.simplesat.io/images/cat-1.5@300.png',
    2: 'https://cdn.simplesat.io/images/cat-2.5@300.png',
    3: 'https://cdn.simplesat.io/images/cat-3.5@300.png',
    4: 'https://cdn.simplesat.io/images/cat-4.5@300.png',
    5: 'https://cdn.simplesat.io/images/cat-5.5@300.png',
  },
}

exports.catAnimated = {
  small: {
    1: 'https://cdn.simplesat.io/images/cat-1.5@100.gif',
    2: 'https://cdn.simplesat.io/images/cat-2.5@100.gif',
    3: 'https://cdn.simplesat.io/images/cat-3.5@100.gif',
    4: 'https://cdn.simplesat.io/images/cat-4.5@100.gif',
    5: 'https://cdn.simplesat.io/images/cat-5.5@100.gif',
  },
  big: {
    1: 'https://cdn.simplesat.io/images/cat-1.5@300.gif',
    2: 'https://cdn.simplesat.io/images/cat-2.5@300.gif',
    3: 'https://cdn.simplesat.io/images/cat-3.5@300.gif',
    4: 'https://cdn.simplesat.io/images/cat-4.5@300.gif',
    5: 'https://cdn.simplesat.io/images/cat-5.5@300.gif',
  },
}

exports.autotaskNoteExample = 'https://cdn.simplesat.io/images/autotask-note-example.png'
exports.connectWiseNoteExample = 'https://cdn.simplesat.io/images/connectwise-note-example.png'
exports.zendeskCommentExample = 'https://cdn.simplesat.io/images/zendesk-rating-comment-example.png'
exports.zendeskSatisfactionWriteBack =
  'https://cdn.simplesat.io/images/zendesk-satisfaction-write-back.png'

exports.surveyBackgroundPatterns = [
  {
    image: 'https://cdn.simplesat.io/images/pattern/pattern-01.png',
    thumbnail: 'https://cdn.simplesat.io/images/pattern/pattern-01-thumbnail.png',
  },
  {
    image: 'https://cdn.simplesat.io/images/pattern/pattern-02.png',
    thumbnail: 'https://cdn.simplesat.io/images/pattern/pattern-02-thumbnail.png',
  },
  {
    image: 'https://cdn.simplesat.io/images/pattern/pattern-03.png',
    thumbnail: 'https://cdn.simplesat.io/images/pattern/pattern-03-thumbnail.png',
  },
  {
    image: 'https://cdn.simplesat.io/images/pattern/pattern-04.png',
    thumbnail: 'https://cdn.simplesat.io/images/pattern/pattern-04-thumbnail.png',
  },
  {
    image: 'https://cdn.simplesat.io/images/pattern/pattern-05.png',
    thumbnail: 'https://cdn.simplesat.io/images/pattern/pattern-05-thumbnail.png',
  },
  {
    image: 'https://cdn.simplesat.io/images/pattern/pattern-06.png',
    thumbnail: 'https://cdn.simplesat.io/images/pattern/pattern-06-thumbnail.png',
  },
  {
    image: 'https://cdn.simplesat.io/images/pattern/pattern-07.png',
    thumbnail: 'https://cdn.simplesat.io/images/pattern/pattern-07-thumbnail.png',
  },
  {
    image: 'https://cdn.simplesat.io/images/pattern/pattern-08.png',
    thumbnail: 'https://cdn.simplesat.io/images/pattern/pattern-08-thumbnail.png',
  },
  {
    image: 'https://cdn.simplesat.io/images/pattern/pattern-09.png',
    thumbnail: 'https://cdn.simplesat.io/images/pattern/pattern-09-thumbnail.png',
  },
]



//////////////////
// WEBPACK FOOTER
// ../packages/simplesat-config/config/images.js
// module id = 4984
// module chunks = 13